import Vue from 'vue'

const base = window.Cypress ? Cypress.env('guideURL') : process.env.VUE_APP_HELP_PAGE_PREFIX

export const links = {
  base,

  planWorkflow: {
    url: `${base}/workflow-steps/consideration#plan-workflow`,
    tooltip: 'Workflow Steps - Plan Workflow',
    title: 'Consideration'
  },

  requestPrice: {
    url: `${base}/workflow-steps/consideration#request-price`,
    tooltip: 'Workflow Steps - Request Price',
    title: 'Consideration'
  },

  priceEntry: {
    url: `${base}/workflow-steps/negotiation#price-entry`,
    tooltip: 'Workflow Steps - Price Entry',
    title: 'Negotiation'
  },

  expiringLicenses: {
    url: `${base}/workflow-steps/negotiation#expiring-licenses`,
    tooltip: 'Workflow Steps - Expiring Licenses',
    title: 'Negotiation'
  },

  finalizeLicenses: {
    url: `${base}/workflow-steps/negotiation#finalize-licenses`,
    tooltip: 'Workflow Steps - Finalize Licenses',
    title: 'Negotiation'
  },

  titleLists: {
    url: `${base}/workflow-steps/negotiation#title-lists`,
    tooltip: 'Workflow Steps - Title Lists',
    title: 'Negotiation'
  },

  stakeholders: {
    url: `${base}/workflow-steps/decision#stakeholders`,
    tooltip: 'Workflow Steps - Stakeholders',
    title: 'Decision'
  },

  evaluation: {
    url: `${base}/workflow-steps/decision#evaluation`,
    tooltip: 'Workflow Steps - Evaluation',
    title: 'Decision'
  },

  decision: {
    url: `${base}/workflow-steps/decision#decision`,
    tooltip: 'Workflow Steps - Decision',
    title: 'Decision'
  },

  placeOrders: {
    url: `${base}/workflow-steps/decision#place-orders`,
    tooltip: 'Workflow Steps - Place Orders',
    title: 'Decision'
  },

  approveInvoices: {
    url: `${base}/workflow-steps/invoicing#approve-invoices`,
    tooltip: 'Workflow Steps - Approve Invoices',
    title: 'Invoicing'
  },

  vendorPayments: {
    url: `${base}/workflow-steps/invoicing#vendor-payments`,
    tooltip: 'Workflow Steps - Vendor Payments',
    title: 'Invoicing'
  },

  implementation: {
    url: `${base}/workflow-steps/implementation#implementation`,
    tooltip: 'Workflow Steps - Implementation',
    title: 'Implementation'
  },

  informUsers: {
    url: `${base}/workflow-steps/implementation#inform-users`,
    tooltip: 'Workflow Steps - Inform Users',
    title: 'Implementation'
  },

  workflowIntro: {
    url: `${base}/workflow-steps/workflow-introduction`,
    tooltip: 'Workflow',
    title: 'Introduction'
  },

  licenseQualifiers: {
    url: `${base}/licenses/license-terms#license-qualifiers`,
    tooltip: 'License Qualifiers',
    title: 'License Terms + Qualifier Labels'
  },

  licenseTermLabels: {
    url: `${base}/licenses/license-terms#license-term-labels`,
    tooltip: 'License Term Labels',
    title: 'License Terms + Qualifier Labels'
  },

  importGeneralInstructions: {
    url: `${base}/importing-data/importing-data-general-instructions`,
    tooltip: 'Importing data - general instructions',
    title: 'Importing data - general instructions'
  },

  importSubscriptions: {
    url: `${base}/importing-data/importing-subscriptions`,
    tooltip: 'Importing Subscriptions',
    title: 'Importing Subscriptions'
  },

  importProviders: {
    url: `${base}/importing-data/importing-publishers-and-vendors`,
    tooltip: 'Importing Publishers and Vendors',
    title: 'Importing Publishers and Vendors'
  },

  financialInsights: {
    url: `${base}/financial-insights`,
    tooltip: 'Financial Insights guide',
    title: 'Financial Insights'
  },

  predictions: {
    url: `${base}/predictions`,
    tooltip: 'Predictions guide',
    title: 'Predictions'
  },

  kanban: {
    url: `${base}/kanban`,
    tooltip: 'Kanban Board',
    title: 'Kanban Board'
  },

  subscriptionPage: {
    url: `${base}/getting-started/subscription-page`,
    tooltip: 'Subscription page',
    title: 'Subscription Page'
  },

  productPage: {
    url: `${base}/getting-started/product-page`,
    tooltip: 'Product page',
    title: 'Product Page'
  },

  vendorPage: {
    url: `${base}/getting-started/vendor-page`,
    tooltip: 'Vendor page',
    title: 'Vendor Page'
  },

  publisherPage: {
    url: `${base}/getting-started/publisher-page`,
    tooltip: 'Publisher page',
    title: 'Publisher Page'
  },

  license: {
    url: `${base}/licenses/license-basics`,
    tooltip: 'License Basics',
    title: 'License Basics'
  },

  reports: {
    url: `${base}/reports`,
    tooltip: 'Reports',
    title: 'Reports'
  },

  memberSettings: {
    url: `${base}/system-settings/member-user-settings#member-settings`,
    tooltip: 'Member Settings',
    title: 'Member + User Settings'
  },

  systemSettings: {
    url: `${base}/system-settings`,
    tooltip: 'System Settings',
    title: 'Member + User Settings'
  },

  userSettings: {
    url: `${base}/system-settings/member-user-settings#users-settings`,
    tooltip: 'User Settings',
    title: 'Member + User Settings'
  },

  workflowSettings: {
    url: `${base}/system-settings/workflow-settings`,
    tooltip: 'Workflow Settings',
    title: 'Workflow Settings'
  },

  financialSettings: {
    url: `${base}/system-settings/financial#financial-settings`,
    tooltip: 'Financial settings',
    title: 'Financial'
  },

  productTypes: {
    url: `${base}/system-settings/product-types-subject-categories#product-types`,
    tooltip: 'Product types',
    title: 'Product Types + Subject Categories'
  },

  subjectCategories: {
    url: `${base}/system-settings/product-types-subject-categories#subject-categories`,
    tooltip: 'Subject categories',
    title: 'Product Types + Subject Categories'
  },

  forms: {
    url: `${base}/system-settings/forms`,
    tooltip: 'Forms',
    title: 'Forms'
  },

  departments: {
    url: `${base}/system-settings/departments-stakeholders#departments`,
    tooltip: 'Departments',
    title: 'Departments + Stakeholders'
  },

  stakeholdersPage: {
    url: `${base}/system-settings/departments-stakeholders#stakeholders`,
    tooltip: 'Stakeholders',
    title: 'Departments + Stakeholders'
  },

  usageStats: {
    url: `${base}/usage-statistics`,
    tooltip: 'Usage statistics',
    title: 'Usage Statistics'
  }
}

Vue.mixin({
  computed: {
    __guide() {
      return links
    }
  }
})
